import React, { useState, useEffect, useCallback } from 'react';
import { getClientProfile } from '../../api/product';
import userIcon from '../../assets/user-1.svg';

const UserInfo = () => {
	const [clientData, setClientData] = useState(null);
	const [error, setError] = useState(null);
	const [loading, setLoading] = useState(true);

	const firstName = clientData?.structured_profile?.personal_info?.first_name;
	const lastName = clientData?.structured_profile?.personal_info?.last_name;
	const email = clientData?.structured_profile?.personal_info?.email;

	const fetchData = useCallback(async () => {
		try {
			setLoading(true);
			setError(null);

			const data = await getClientProfile();
			setClientData(data);
		} catch (error) {
			console.log(error);
		} finally {
			setLoading(false);
		}
	}, []);

	useEffect(() => {
		if (!clientData) {
			fetchData();
		}
	}, [clientData, fetchData]);

	return (
		<section className="absolute w-full bottom-0 border-t-[1px] border-gray-200">
			<div>
				<div className="flex items-center gap-2 p-4">
					{firstName && lastName ? (
						<div className="w-12 h-12 bg-gradient-to-r from-blue-600 to-green-400 rounded-[4px] flex items-center justify-center font-inter text-white text-[16px]/[16px]">
							{firstName?.charAt(0)}
							{lastName?.charAt(0)}
						</div>
					) : (
						<div className="w-12 h-12 bg-gradient-to-r from-blue-600 to-green-400 rounded-[4px] flex items-center justify-center font-inter text-white text-[16px]/[16px]">
							<img src={userIcon} alt="incognito user" className="w-12 h-12 rounded-[4px]" />
						</div>
					)}
					<div className="font-inter flex flex-col gap-[4px]">
						{firstName && lastName && (
							<p className="text-[#111827] text-[16px]/[16px] font-semibold">
								{firstName} {lastName}
							</p>
						)}
						{email && <p className="text-[#4B5563] text-[14px]/[14px]">{email}</p>}
					</div>
				</div>
			</div>
		</section>
	);
};

export default UserInfo;
